import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiRightDrawer } from "../../../../components";
import { addFeatureRoleMapping, deleteFeatureRoleMapping, getFeatureNotInRoles, getFeatureRoleMapping } from "../apiCall";
import { FeaturesKeys } from "../entity";
import { APIParams } from "../../role/apiCall";
import { useAppSelector } from "../../../../store/hooks";
import CheckListSearch from "../../../../components/CheckListSearch";

export const FeatureRolesMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState(false);
  const crud = useAppSelector(state => state.crud);
  const name = "Roles";

  const onClickPlus = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const getOptions = useCallback(async (params: APIParams) =>
    await getFeatureNotInRoles({ ...params, request: { ...params.request, ...request } })
    , [request])

  const onSubmit = useCallback(async (params: APIParams) => {
    const { ModuleId, MenuId } = crud[FeaturesKeys.get]?.data;

    if (!params.request) return;
    let arr = params.request[name];
    arr = arr?.map((val: any) => ({
      ModuleId,
      MenuId,
      RoleId: val
    }));

    params.request[name] = arr;
    return await addFeatureRoleMapping({ ...params, request: { ...params.request, ...request } })
  }, [request])


  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isAssociationButton={true}

        getPagingData={getFeatureRoleMapping}
        pagingAPIrequest={request}
        pagingAPIKey={FeaturesKeys.getRole}

        onDelete={deleteFeatureRoleMapping}
        deletePagingAPIKey={FeaturesKeys.deleteRole}

        // pagingColumns={column}
        visibleColumns={{
          FeatureName: false,
          DisplayName: false
        }}
        onClickPlus={onClickPlus}

        isRightMenu
        disableEditAction
        disableViewAction
      />
      <MuiRightDrawer open={open} width='40%' onClose={onClose}>
        <CheckListSearch
          getOptions={getOptions}
          displayExpr={'DisplayName'}
          listKey={FeaturesKeys.notInRole}
          label='Add Roles'
          name='Roles'
          onSubmit={onSubmit}
          onClose={onClose}
          pagingAPIKey={FeaturesKeys.getRole}
        />
      </MuiRightDrawer>
    </>
  );
};
